import { Chip } from "@mui/material";
import { Link } from "react-router-dom";

const TeamButton = (props) => {
  return (
    <Chip
      label={props.team.name}
      component={Link}
      to={"/team/" + props.team.id}
      clickable
      variant="outlined"
      sx={{ m: 0.5 }}
    />
  );
};

export default TeamButton;
